module.exports = __webpack_public_path__ + "yaen-1930ebb0.webp";